// Command definitions and responses
export const commands = {
  help: [
    "Available commands:",
    "",
    "  help          - Show this help message",
    "  about         - Learn more about me",
    "  skills        - View my technical skills",
    "  experience    - Check my work experience",
    "  contact       - Get in touch with me",
    "  education     - View my educational background",
    "  certifications - See my certifications & achievements",
    "  case-study    - Deep dive on one piece of work",
    "  projects      - List my public repositories (live from GitHub)",
    "  resume        - Download my resume",
    "  theme         - Switch colour scheme",
    "  clear         - Clear the terminal",
    "  sudo          - Try it and see what happens 😉",
    "",
    "Press ⌘K / Ctrl+K to search everything. Tab completes, ↑↓ recalls history."
  ],

  about: [
    "Hi there — I'm ATTUUL GERIYAN",
    "",
    "Applied AI Lead building agentic workflows and high-performance backends",
    "",
    "Currently Applied AI Lead at Agito Global, where I:",
    "   • Pair Claude API, MCP servers and Claude Code to diagnose and fix production issues",
    "   • Build LLM-powered operations assistants (LangChain/Ollama) over live enterprise data",
    "   • Design model-agnostic, read-only tool layers for safe, traceable AI automation",
    "   • Drive AI adoption org-wide through enablement sessions and reusable tooling",
    "",
    "I specialize in:",
    "   • Applied AI engineering — RAG, MCP, agentic workflows, LLM tool layers",
    "   • Backend development with .NET Core, Django, Python & Java",
    "   • Multi-cloud infrastructure (AWS, Azure, GCP) automation",
    "   • High-throughput, event-driven microservices",
    "",
    "Fun fact: cut a client's inference cost from $2/20 queries to $0",
    "   by swapping a hosted API for a locally served open-weight model!",
    ""
  ],

  skills: [
    "TECHNICAL SKILLS",
    "",
    "Languages",
    "   Python • C# • Java • JavaScript • SQL",
    "",
    "AI Engineering",
    "   LangChain • Ollama • RAG • Model Context Protocol (MCP) • Claude Code • n8n • Agentic Workflows",
    "",
    "Backend & Data",
    "   .NET Core • Django • REST • GraphQL • SQL Server • PostgreSQL • Microservices • Event-Driven",
    "",
    "Cloud & DevOps",
    "   AWS (Lambda, API Gateway, S3) • Azure (Functions) • GCP (Cloud Functions, Pub/Sub) • Docker",
    "",
    "Specializations",
    "   • Agentic & tool-augmented LLM systems",
    "   • Multi-cloud infrastructure automation",
    "   • RESTful & GraphQL API development",
    "   • Database performance optimization",
    ""
  ],

  experience: [
    "WORK EXPERIENCE",
    "",
    "Agito Global | Applied AI Lead",
    "  January 2026 - Present | Remote, UK",
    "",
    "• Resolved a P1 throughput crisis for a logistics client by pairing Claude API with a custom",
    "  MCP server to diagnose SQL Server index gaps — 6x throughput lift (1,800 → 11,000 parcels/hour) in 8 days",
    "• Shipped AskMomentum, a Python/LangChain/Ollama operations assistant spanning 28 SQL Server",
    "  databases, 12 GraphQL schemas and ElasticSearch logs; cut inference cost from $2/20 queries to $0",
    "  by replacing a hosted-API prototype with a locally served open-weight model",
    "• Planned a model-agnostic, read-only tool layer with async job APIs and per-answer tracing;",
    "  instrumentation attributed 99.7% of latency to inference, driving the GPU sizing case",
    "• Redirected three proposed approaches via measured spikes instead of argument, holding scope",
    "  through two mid-sprint architecture revisions and still delivering the demo on date",
    "• Established a TypeScript MCP server automating SQL Server ops & test data generation across",
    "  four environments, cutting manual DB maintenance 85%; adopted org-wide by QA and DB teams",
    "• Delivered a RAG system auto-generating PBIs for Business Analysts and an ADO-integrated QA workflow",
    "• Drove AI adoption across 40+ engineers via weekly enablement sessions and a slash-command library",
    "",
    "Agito Global | Software Engineer II - Backend",
    "  August 2025 - January 2026",
    "",
    "• Engineered an Industry 4.0 warehouse robot automation platform in .NET microservices for pallet",
    "  workflows, equipment monitoring and ERP integration — 60% less manual intervention, 93.8% uptime",
    "• Cut PBI and bug cycle time 72.8% by pairing Claude Code with a knowledge base supplying scoped",
    "  repository context per work item",
    "• Built a multi-agent PR review pipeline on headless Claude Code and Azure DevOps branch policies,",
    "  automating inline comments and approvals; caught silent rollback failures pre-merge",
    "",
    "AB InBev | Software Engineer II",
    "  November 2023 - July 2025 | Bengaluru, India",
    "",
    "• Improved and deployed cloud-native microservices on AWS (Lambda, API Gateway, S3) and GCP",
    "  (Cloud Functions, Pub/Sub) for high availability and low latency",
    "• Built interactive dashboards integrating multi-cloud inventory data, cutting cloud overspend",
    "  by $75,000 annually",
    "• Automated back-end operations with .NET Core and SQL, reducing man hours 70%",
    "• Integrated AWS Cost Explorer and GCP billing APIs into an in-house Cloud Service Management",
    "  portal, saving $400K annually via automated right-sizing and tagging",
    "",
    "AB InBev | Software Engineer",
    "  February 2023 - November 2023 | Bengaluru, India",
    "",
    "• Created a serverless Python lock-management API on Azure Functions (Durable Functions)",
    "  governing 500+ resources with zero downtime",
    "• Automated Puppet agent rollout via CloudBolt and Python, reaching 95% coverage across",
    "  11+ global regions",
    "",
    "Perfios Software Solutions | SDE",
    "  February 2022 - December 2022 | Bengaluru, India",
    "",
    "• Designed RESTful endpoints in Java (Spring Boot) exposing banking analytics as JSON APIs",
    "  consumed by 20+ front-end teams",
    ""
  ],

  contact: [
    "GET IN TOUCH",
    "",
    "Phone      +91 96112 62735",
    "Email      atuldpk06@gmail.com",
    "LinkedIn   https://www.linkedin.com/in/attuul-geriyan/",
    "GitHub     https://github.com/attuulGeriyan",
    "",
    "Feel free to reach out for:",
    "   • Collaboration opportunities",
    "   • Technical discussions",
    "   • Job opportunities",
    "   • Open source contributions",
    "",
    "I typically respond within 24 hours!",
    ""
  ],

  education: [
    "EDUCATION",
    "",
    "Dayananda Sagar College of Engineering",
    "  Bengaluru, India",
    "  Bachelor of Computer Science Engineering",
    "  CGPA: 8.98/10.0",
    "  August 2022",
    ""
  ],

  certifications: [
    "ACHIEVEMENTS & CERTIFICATIONS",
    "",
    "Awards",
    "   • Emerging Tech Award – AI Adaptation (2026)",
    "   • Innovation Award – Automation & Dashboarding (2024)",
    "",
    "Certifications",
    "   • MCP, Claude API and RAG by Anthropic",
    "   • Azure AZ-900 – Microsoft Azure Fundamentals",
    "",
    "Key Achievements",
    "   • 6x throughput lift for a logistics client in 8 days",
    "   • $400K+ annual cost savings through billing automation",
    "   • 85% reduction in manual DB maintenance via a self-built MCP server",
    "   • 72.8% faster PBI/bug cycle time using AI-assisted workflows",
    ""
  ],

  resume: [
    "RESUME",
    "",
    "Downloading resume...",
    "If the download doesn't start, grab it here:",
    "   /Attuul_Geriyan_Resume.pdf",
    ""
  ]
};
